import { useState } from 'react';
import { iniciarSesion } from './apidoo';
import './Login.css';

export default function Login({ onLogin }) {
  const [usuario, setUsuario] = useState('');
  const [clave, setClave]     = useState('');
  const [error, setError]     = useState('');
  const [cargando, setCargando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!usuario.trim() || !clave) return;
    setCargando(true);
    setError('');
    try {
      await iniciarSesion(usuario.trim(), clave);
      onLogin();
    } catch (err) {
      console.error('Login error:', err);
      setError(err?.message || 'Usuario o clave incorrectos.');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-header">
          <div className="login-avatar">S</div>
          <h1 className="login-titulo">Sofía</h1>
          <p className="login-subtitulo">Asistente Virtual</p>
          <p className="login-clinica">Clínica Plaza Coinco</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <input
            className="login-input"
            type="text"
            placeholder="Usuario"
            value={usuario}
            onChange={e => setUsuario(e.target.value)}
            disabled={cargando}
            autoComplete="username"
            autoFocus
          />
          <input
            className="login-input"
            type="password"
            placeholder="Clave"
            value={clave}
            onChange={e => setClave(e.target.value)}
            disabled={cargando}
            autoComplete="current-password"
          />
          {error && <p className="login-error">{error}</p>}
          <button
            className="login-btn"
            type="submit"
            disabled={cargando || !usuario.trim() || !clave}
          >
            {cargando ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}
